/* eslint-disable */
import { select, call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import LoveActions from '../Redux/LoveRedux'

const loveFindTimeStamp = function loveFindTimeStamp(state, action) {
  const { changes } = state
  const { userId, postId } = action // relationship, find most recent request
  for (let i = 0; i < changes.length; i++)
    if (changes[i].UserId == userId && changes[i].PostId == postId && changes[i].State == 'waiting')
      return changes[i].TimeStamp;
  return null;
}

export const quickLove = function * quickLove(api, action) {
  return
}
export const lovePost = function* lovePost(api, action) {
  try {
    console.tron.display({
      name: 'lovePost',
      preview: "LoveSagas",
      value: {
        action: action
      }
    })

    // better still would be to have one shared function with love/unlove
    const { userId, postId } = action
    const state = yield select() // grab state
    const { love } = state
    const timeStamp = loveFindTimeStamp(love, action)
    console.tron.log("lovePost loveFindTimeStamp: " + timeStamp)
    if (timeStamp == null) {
      console.tron.log("LoveSagas lovePost could not find change, must not be valid, aborting...")
      return
    }
    // testPause(2000);
    // yield call(testPause, 2000) // stops all

    // make the call to the api
    const response = yield call(api.lovePost, postId)
    // include the timestamp so we can update state.changes
    const responsePlus = Object.assign(response, {TimeStamp: timeStamp});

    if (response.ok) {
      const { data } = response
      const apiResponse = data
      console.tron.display({
        name: 'lovePost',
        preview: "response, response data",
        value: {
          response: response,
          apiResponse: apiResponse,
          data: apiResponse.data,
        }
      })
      if (apiResponse.data.length > 0 && apiResponse.data[0])
        yield put(LoveActions.loveSuccess(responsePlus))
      else
        yield put(LoveActions.loveFailure(responsePlus))
    } else {
      yield put(LoveActions.loveFailure(responsePlus))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'lovePost error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}

export const unlovePost = function* unlovePost(api, action) {
  try {
    console.tron.display({
      name: 'unlovePost',
      preview: "LoveSagas",
      value: {
        action: action
      }
    })

    const { userId, postId } = action
    const state = yield select()
    const { love } = state
    const timeStamp = loveFindTimeStamp(love, action)
    console.tron.log("unlovePost loveFindTimeStamp: " + timeStamp)
    if (timeStamp == null) {
      console.tron.log("LoveSagas unlovePost could not find change, must not be valid, aborting...")
      return
    }
    // testPause(2000);
    // yield call(testPause, 2000) // stops all

    // make the call to the api
    const response = yield call(api.unlovePost, postId)
    // include the timestamp so we can update state.changes
    const responsePlus = Object.assign(response, {TimeStamp: timeStamp});

    if (response.ok) {
      const { data } = response
      const apiResponse = data
      console.tron.display({
        name: 'lovePost',
        preview: "response, response data",
        value: {
          response: response,
          apiResponse: apiResponse,
          data: apiResponse.data,
        }
      })
      if (apiResponse.data.length == 0)
        yield put(LoveActions.unloveSuccess(responsePlus))
      else
        yield put(LoveActions.unloveFailure(responsePlus))
    } else {
      yield put(LoveActions.unloveFailure(responsePlus))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'unlovePost error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}
